import { path } from 'ramda';

import { IState } from '../../store';
import { IFloorPlan } from '../../types/floorPlan';
import { IPhotoSchema } from '../../types/newbuildingTiledCarousel';

export const getFloorPlan = (state: IState): IPhotoSchema | null => {
  const floorPlan = path<IFloorPlan>(['offerData', 'floorPlan'], state);

  if (!floorPlan) {
    return null;
  }

  return {
    fullUrl: floorPlan.imageUrl,
    thumbnailUrl: floorPlan.imageUrl,
    polygonPath: floorPlan.polygonPath,
    isLayout: false,
    isFloorPlan: true,
  };
};
